import { GlobalState } from '@leverege/ui-redux';
import DeviceGroupItemDelegate from "./DeviceGroupItemDelegate.js";
import AbstractFotaGroupDelegate from "../AbstractFotaGroupDelegate.js";
export default class DeviceGroupGroupDelegate extends AbstractFotaGroupDelegate {
  constructor(options) {
    super(options);
    this.itemDelegateClass = DeviceGroupItemDelegate;
  }
  getApi() {
    return this.api.deviceGroup();
  }
  getImagineGroup(id) {
    return this.item(id).getImagineGroup();
  }
  getImagineGroupItem(state = GlobalState.get(), id) {
    return this.item(id).getImagineGroupItem(state);
  }
}